export const CLEAR_CONVERSATION_ATTRIBUTES = 'CLEAR_CONVERSATION_ATTRIBUTES';
export const SET_CONVERSATION_ATTRIBUTES = 'SET_CONVERSATION_ATTRIBUTES';
export const SET_LOCAL_STORAGE_CONVERSATION_ATTRIBUTES =
  'SET_LOCAL_STORAGE_CONVERSATION_ATTRIBUTES';
export const SET_WIDGET_APP_CONFIG = 'SET_WIDGET_APP_CONFIG';
export const SET_WIDGET_COLOR = 'SET_WIDGET_COLOR';
export const UPDATE_CONVERSATION_ATTRIBUTES = 'UPDATE_CONVERSATION_ATTRIBUTES';
export const UPDATE_CONVERSATION_QUEUE_STATUS =
  'UPDATE_CONVERSATION_QUEUE_STATUS';
export const UPDATE_CONVERSATION_ARCHIVE_STATUS =
  'UPDATE_CONVERSATION_ARCHIVE_STATUS';
export const UPDATE_CONVERSATION_CUSTOM_ATTRIBUTES =
  'UPDATE_CONVERSATION_CUSTOM_ATTRIBUTES';
export const TOGGLE_WIDGET_OPEN = 'TOGGLE_WIDGET_OPEN';
export const SET_HEADER_MENU_VISIBILITY = 'SET_HEADER_MENU_VISIBILITY';
export const SET_WIDGET_EXPANDED = 'SET_WIDGET_EXPANDED';
export const SET_IS_MOBILE = 'SET_IS_MOBILE';
export const SET_WINDOW_SIZE = 'SET_WINDOW_SIZE';
export const SET_IS_FOCUSED = 'SET_IS_FOCUSED';
export const SET_REFERRER_HOST = 'SET_REFERRER_HOST';
export const SET_BUBBLE_VISIBILITY = 'SET_BUBBLE_VISIBILITY';
export const SET_ROUTE_UPDATE_STATE = 'SET_ROUTE_UPDATE_STATE';
export const SET_WIDGET_DARK_MODE = 'SET_WIDGET_DARK_MODE';
